import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';
import api from '../api';
import handleError from '../helpers/requestErrorHandler';
import {getPath} from "../utils/Router";
import UserStore from "../stores/UserStore";
import cookie from 'react-cookie';
import config from "../config";

const { dispatch } = store;
const CurrencyActions = {    
    getCurrencies() {
        api.getCurrencies()
        .then(data => {
            dispatch({
                type  : AppConstants.CURRENCIES_LOAD_SUCCESS,
                items : data.response || {}
            });
        })
        .catch(err => {
            handleError(err);
        });
    },

    getCurrentCurrencyRatios() {
        api.getCurrentCurrencyRatios()
            .then(data => {
                dispatch({
                    type  : AppConstants.CURRENCY_CURRENT_RATIOS_LOAD_SUCCESS,
                    items : data.response || {}
                });
            })
            .catch(err => {
                handleError(err);
            });
    },

    convertCurrentCurrency(params, callback) {
        return api.convertCurrentCurrency(params)
            .then(data => {
                dispatch({
                    type  : AppConstants.CURRENT_CURRENCY_CONVERT_SUCCESS,
                    items : data.response || {}
                });

                callback && callback();
            })
            .catch(err => {
                handleError(err);
            })
    },

    getPaymentMethods() {
        return api.getPaymentMethods()
            .then(data => {
                dispatch({
                    type  : AppConstants.PAYMENT_METHODS_LOAD_SUCCESS,
                    items : data.response || {}
                });
            })
            .catch(err => {
                handleError(err);
            });

    },

    getPaymentMethodStat() {
        return api.getPaymentMethodStat()
            .then(data => {
                if (false === data.response.issetAny) {
                    if (confirm(UserStore.getTranslation().notyMessages.youDontHaveAnyPaymentPleaseSetActive)) {
                        window.location = getPath('profile') + '?addAccount';
                    } else {
                        cookie.save(config.notShowNoPaymentMsg, true, { path: config.defaultRoute });
                    }
                } else if (false === data.response.issetActive) {
                    if (confirm(UserStore.getTranslation().notyMessages.youDontHaveActivePaymentPleaseSetActive)) {
                        window.location = getPath('profile');
                    } else {
                        cookie.save(config.notShowNoActivePaymentMsg, true, { path: config.defaultRoute });
                    }
                }
            })
            .catch(err => {
                handleError(err);
            });
    },

    getPaymentSystems() {
        return api.getPaymentSystems()
            .then(data => {
                dispatch({
                    type  : AppConstants.PAYMENT_SYSTEMS_LOAD_SUCCESS,
                    items : data.response || {}
                });
            })
            .catch(err => {
                handleError(err);
            });

    },

    getAllowPaymentSystems() {
        return api.getAllowPaymentSystems()
            .then(data => {
                dispatch({
                    type  : AppConstants.ALLOW_PAYMENT_SYSTEMS_LOAD_SUCCESS,
                    items : data.response || {}
                });
            })
            .catch(err => {
                handleError(err);
            });

    },

    getCurrencyRatios(params) {
        dispatch({
            type  : AppConstants.CURRENCY_RATIOS_START_LOADING
        });

        return api.searchCurrencyRatios(params)
            .then(data => {
                dispatch({
                    type  : AppConstants.CURRENCY_RATIOS_LOAD_SUCCESS,
                    items : data.response || {}
                });
            })
            .catch(err => {
                handleError(err);
            });
    },

    deletePaymentAccount(params, success) {
        return api.deletePaymentAccount(params)
            .then(data => {
                success && success(data);
            })
            .catch(err => {
                handleError(err);
            });
    },

    savePaymentAccount(apiMethod, params) {
        return api[apiMethod](params)
            .then(data => {
                return data;
            })
            .catch(err => {
                handleError(err, () => {});
                return err;
            });
    },
};

export default CurrencyActions;
